import genericStore from "../generic_store";

export default {
    namespaced: genericStore.namespaced,
    state: {
        ...genericStore.state,
        endpoint: "jobs",
        object: "job",
        header: [
            { text: "Nombre", value: "name" },
            { text: "Icono", value: "icon" },
            { text: "Especialidades", value: "new_speciality", sortable: false  },
            { text: "Acciones", value: "actions", sortable: false }
        ]
    },
    mutations: {
        ...genericStore.mutations
    },
    actions: {
        ...genericStore.actions
    },
    getters: {
        ...genericStore.getters
    }
};
